import { Pipe, PipeTransform } from '@angular/core';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'formatAlarmTableData'
})
export class FormatAlarmTableDataPipe implements PipeTransform {

  transform(alarms: MonitoringAlarm[]): MonitoringAlarm[] {
    return alarms.map(alarm => {
      return {
        ...alarm,
        trainName: `${alarm.trainName}`
      };
    });
  }

}
